import { http } from '../../../api'

const cookie = {
  namespaced: true,
  state: {
    cookieList: [],
    cookie: null
  },
  actions: {
    getAllData: ({ commit }, params) => {
      let url = '/cookie'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setList', res.data.data)
        return res.data
      })
    },
    create: ({ commit }, params) => {
      return http.post('/cookie', params).then(res => {
        return res.data
      })
    },
    delete: ({ commit }, params) => {
      return http.delete('/cookie/' + params.id).then(res => {
        if (res.data.deleteType === 'forceDelete') {
          commit('setRemoveList', params.id)
        } else {
          commit('setUpdateStatus', { id: params.id, status: 'inactive' })
        }
      })
    },
    restore: ({ commit }, params) => {
      return http.get('/cookie/' + params.id + '/restore').then(res => {
        commit('setUpdateStatus', { id: params.id, status: 'active' })
      })
    },
    getData: ({ commit }, params) => {
      return http.get('/cookie/' + params.id).then(res => {
        commit('setData', res.data.data)
      })
    },
    update: ({ commit }, params) => {
      return http.put('/cookie/' + params.id, params.data).then(res => {
      })
    }
  },
  mutations: {
    setList (state, data) {
      state.cookieList = data
    },
    setRemoveList (state, id) {
      state.cookieList = state.cookieList.filter(item => item.id !== id)
    },
    setUpdateStatus (state, data) {
      state.cookieList = state.cookieList.map(item => {
        if (item.id === data.id) {
          item.status = data.status
        }
        return item
      })
    },
    setData (state, data) {
      state.cookie = data
    }
  },
  getters: {
    cookieList: state => state.cookieList,
    cookie: state => state.cookie
  }
}

export default cookie
